<script setup>
// import { Auth } from "aws-amplify";
import { signInWithRedirect } from "aws-amplify/auth";

function signIn() {
  signInWithRedirect();
}

// onMounted(() => {
//   Auth.federatedSignIn();
// });
</script>

<template>
  <v-main>
    <h3>You must sign in</h3>
    <h3 @click="signIn">Sign In</h3>
  </v-main>
</template>
